module.exports = __webpack_public_path__ + "static/pinkfairy2-352c4e572b9634889ece13e102790aa8.png";